<template>
  <div class="rich-text-wrap">
    <v-row>
      <v-col cols="12">
        <h2
          >{{ fieldLabel }}
          <transition name="fade" mode="out-in">
            <v-icon v-if="isDirty" class="ml-1" color="red accent-2"
              >mdi-pencil-outline</v-icon
            >
          </transition>

          <transition name="fade" mode="out-in">
            <v-progress-circular
              class="ml-2"
              v-if="loading"
              indeterminate
              color="blue darken-2"
              size="15"
              width="2"
            />
          </transition>
        </h2>
      </v-col>
    </v-row>
    <div class="editor-wrap pa-4 my-2">
      <RichTextMenus :editor="editor" />
      <EditorContent :editor="editor" />
    </div>
  </div>
</template>

<script>
import {
  Editor,
  // EditorMenuBar,
  EditorContent,
} from 'tiptap'
import {
  HardBreak,
  History,
  BulletList,
  ListItem,
  Heading,
  OrderedList,
  Bold,
  Italic,
  Link,
  Underline,
} from 'tiptap-extensions'
import debounce from 'debounce'
import getHTMLfromContent from '@/utils/getHTMLfromContent'
import RichTextMenus from '@/components/RichTextMenus'
export default {
  name: 'RichText',
  props: {
    content: {
      type: String,
      default: '',
      required: true,
    },
    fieldLabel: {
      type: String,
      required: true,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RichTextMenus,
    EditorContent,
    // EditorMenuBar,
  },
  data() {
    return {
      editorConfig: {
        showToolbar: true,
        extensions: [
          new History(),
          new HardBreak(),
          new ListItem(),
          new BulletList(),
          new Heading({ levels: [1, 2, 3] }),
          new OrderedList(),
          new Bold(),
          new Italic(),
          new Link(),
          new Underline(),
        ],
        onUpdate: this.tiptapUpdate,
      },
    }
  },
  created() {
    this.initEditor()
  },
  methods: {
    initEditor() {
      this.editor = new Editor({
        ...this.editorConfig,
        content: getHTMLfromContent(this.content),
      })
    },
    tiptapUpdate: debounce(function({ getHTML }) {
      let html = getHTML()
      this.$emit('update', html)
    }, 250), // tiptapUpdate
  }, // methods
  beforeDestroy() {
    this.editor.destroy()
  },
  watch: {
    loading(isLoading) {
      this.editor.setOptions({ editable: !isLoading })
    },
    content(newContent) {
      this.editor.setContent(newContent)
    },
  },
}
</script>

<style lang="css">
.editor-wrap {
  border: 1px solid #666;
  border-radius: 5px;
}
.editor-wrap .menubar__button {
  padding-top: 6px;
  padding-bottom: 6px;
  margin-bottom: 6px;
}
</style>

<style lang="scss">
@import '@/assets/tiptap/main.scss';
.editor-wrap {
  font-size: 1.2rem;
  line-height: 1.5;

  .ProseMirror:focus {
    outline: none;
  }

  h1,
  h2,
  h3,
  p,
  ul,
  ol,
  pre,
  blockquote {
    margin: 1rem 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  h1,
  h2,
  h3 {
    line-height: 1.3;
  }
}
</style>
